/** 需要从验证结果中采集的参数名 */
const PARAM_KEYS = ['u_atoken', 'u_asig']
/** sessionStorage 键名：仅用于「下一次请求拼接」 */
const STORAGE_KEY = 'waf_params'
/** 验证 iframe 的 DOM id */
const IFRAME_ID = 'waf-challenge-iframe'
/** 进行中的验证 Promise，避免同时弹出多个验证框 */
let pendingChallenge = null

/**
 * 判断响应是否为 WAF 验证页
 * @param {Object} response axios 响应
 * @returns {boolean}
 */
export function isWafChallengeResponse(response) {
  const headers = response.headers || {}
  const waf = headers.waf || headers.Waf || headers.WAF
  if (String(waf).toLowerCase() === 'true') {
    return true
  }
  const data = response.data
  return typeof data === 'string' && /^\s*<(!DOCTYPE\s+html|html[\s>])/i.test(data)
}

/**
 * 展示 WAF 验证页，通过后保存参数并 resolve
 * @param {string} html 验证页 HTML
 * @returns {Promise<Object.<string, string>>}
 */
export function showWafChallenge(html) {
  if (pendingChallenge) {
    return pendingChallenge
  }

  pendingChallenge = new Promise(function (resolve) {
    var old = document.getElementById(IFRAME_ID)
    if (old) {
      old.remove()
    }

    var iframe = document.createElement('iframe')
    iframe.id = IFRAME_ID
    iframe.style.cssText = 'position:fixed;inset:0;width:100%;height:100%;border:0;z-index:999999;background:#fff;'
    document.body.appendChild(iframe)

    // 将完整 HTML 写入 iframe，保证 script 在独立文档中执行
    var raw = typeof html === 'string' ? html : String(html || '')
    var doc = iframe.contentDocument || iframe.contentWindow.document
    doc.open()
    doc.write(raw)
    doc.close()

    var done = false
    var timer = null

    /**
     * 轮询 iframe / 当前页地址，拿到 u_atoken + u_asig 即视为通过
     */
    function check() {
      if (done) {
        return
      }

      var hrefList = [location.href]
      try {
        hrefList.push(iframe.contentWindow.location.href)
      } catch (e) {
        // 跨域时读不到 iframe 地址，忽略
      }

      var params = null
      for (var i = 0; i < hrefList.length; i++) {
        var href = hrefList[i]
        if (!href || href === 'about:blank' || href === 'about:srcdoc') {
          continue
        }
        var current = collectParamsFromUrl(href)
        if (current.u_atoken && current.u_asig) {
          params = current
          break
        }
      }
      if (!params) {
        return
      }

      done = true
      clearInterval(timer)
      saveParams(params)
      iframe.remove()
      resolve(params)
    }

    iframe.addEventListener('load', check)
    timer = setInterval(check, 500)
  }).then(
    function (params) {
      pendingChallenge = null
      return params
    },
    function (err) {
      pendingChallenge = null
      return Promise.reject(err)
    }
  )

  return pendingChallenge
}

/**
 * 保存参数：sessionStorage（供下次请求拼接）+ cookie（长期保留）
 * @param {Object.<string, string>} params 参数
 */
function saveParams(params) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params || {}))
  Object.keys(params || {}).forEach(function (key) {
    if (params[key]) {
      setCookie(key, params[key])
    }
  })
}

/**
 * 从 URL 中取出指定 query 参数
 * @param {string} url 地址
 * @param {string} key 参数名
 * @returns {string|null}
 */
function getUrlParam(url, key) {
  try {
    const search = (url.split('?')[1] || '').split('#')[0]
    return new URLSearchParams(search).get(key)
  } catch (e) {
    return null
  }
}

/**
 * 从验证成功后的 URL 收集 WAF 参数
 * @param {string} href 地址
 * @returns {Object.<string, string>}
 */
function collectParamsFromUrl(href) {
  const params = {}
  PARAM_KEYS.forEach(function (key) {
    const value = getUrlParam(href, key)
    if (value) {
      params[key] = value
    }
  })
  return params
}

/**
 * 读取 sessionStorage 中的 WAF 参数
 * @returns {Object.<string, string>}
 */
function getParams() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : {}
  } catch (e) {
    return {}
  }
}

/**
 * 写入 cookie
 * @param {string} name 名
 * @param {string} value 值
 */
function setCookie(name, value) {
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=1800`
}

/**
 * 清除 sessionStorage 中的拼接参数（不删 cookie）
 */
export function clearWafTokens() {
  sessionStorage.removeItem(STORAGE_KEY)
}

/**
 * 请求拦截：有 sessionStorage 参数则拼到 query，没有则跳过
 * @param {Object} config axios 配置
 * @returns {Object}
 */
export function applyWafTokensToConfig(config) {
  const params = getParams()
  if (!Object.keys(params).length) {
    return config
  }
  config.params = Object.assign({}, config.params || {}, params)
  config.__wafParamsAttached = true
  return config
}



// WEBPACK FOOTER //
// ./src/plugins/waf.js